import React, { useState } from 'react';
import { Box, Fab, Typography } from '@mui/material';
import FilterComponent from './FilterComponent';
import { FilterData } from 'types/types';
import TuneIcon from '@mui/icons-material/Tune';
import RefreshIcon from '@mui/icons-material/Refresh';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { filters } from 'features/filtersState';
import { useSelector } from 'react-redux';

interface FilterProps {
  dashboardId: string;
  initialFilters: FilterData[];
  podId?: string;
  goFullScreen?: () => void;
  refreshPod?: () => void;
}

const FiltersContainerComponent: React.FC<FilterProps> = ({
  dashboardId,
  initialFilters,
  podId,
  goFullScreen,
  refreshPod,
}) => {
  const [filtersDisplay, setFiltersDisplay] = useState<boolean>(false);
  const filtersState = useSelector(filters);

  const getStringValues = (timestampsString) => {
    const [fromTimestamp, toTimestamp] = timestampsString.split('|');

    const fromDate = new Date(fromTimestamp);
    const toDate = new Date(toTimestamp);

    const fromDateString = fromDate.toISOString().split('T')[0];
    const toDateString = toDate.toISOString().split('T')[0];

    return `${fromDateString} - ${toDateString}`;
  };

  const linkText = (registeredFilter) => {
    if (registeredFilter.type === 'DashboardDescriptorFilterDateRange') {
      return getStringValues(registeredFilter.selectedValues[0].id);
    }
    let returnedText =
      registeredFilter.selectedValues.length > 2
        ? `${registeredFilter.selectedValues.length} items selected`
        : registeredFilter.selectedValues.length === 2
        ? `${registeredFilter.selectedValues
            .map(
              (selectedItem) =>
                registeredFilter.values.find(
                  (item) => item.id === selectedItem.id
                )?.name
            )
            .join(', ')}`
        : registeredFilter.selectedValues.length === 1
        ? `${registeredFilter.selectedValues.map(
            (selectedItem) =>
              registeredFilter.values.find(
                (item) => item.id === selectedItem.id
              )?.name
          )}`
        : 'No Selection';
    return returnedText;
  };

  return (
    <>
      {initialFilters && initialFilters.length > 0 && (
        <div className="filters-main-container">
          <div className="selected-filters-display">
            {initialFilters.map((filter, i) => {
              const registeredFilter = filtersState.find(
                (f) =>
                  f.filterId === filter.filterId &&
                  f.dashboardId === dashboardId &&
                  f.loaded
              );
              return (
                registeredFilter &&
                registeredFilter.selectedValues &&
                registeredFilter.selectedValues.length > 0 && (
                  <Box key={i} className="list-component-container">
                    <span>
                      <Typography variant="button" gutterBottom>
                        {registeredFilter.label}:
                      </Typography>
                    </span>
                    <span className="list-component-link-container">
                      {linkText(registeredFilter)}
                    </span>
                  </Box>
                )
              );
            })}
          </div>
          <Fab
            size="small"
            color="primary"
            aria-label="Refresh"
            onClick={refreshPod}
          >
            <RefreshIcon />
          </Fab>
          {goFullScreen && (
            <Fab
              size="small"
              color="primary"
              aria-label="FullScreen"
              onClick={goFullScreen}
            >
              <FullscreenIcon />
            </Fab>
          )}
          <div className="filters-main">
            <Fab
              size="small"
              color="primary"
              aria-label="Filters"
              onClick={() => setFiltersDisplay(!filtersDisplay)}
            >
              <TuneIcon />
            </Fab>
            <div className="hidden-filter-selection">
              <Box className="filters-container">
                {initialFilters.map((filter, i) => (
                  <Box key={i}>
                    <FilterComponent
                      filter={filter}
                      dashboardId={dashboardId}
                      podId={podId}
                    />
                  </Box>
                ))}
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FiltersContainerComponent;
